export const Skeleton = () => (
  <div className="bg-neutral-150 h-[8px] my-1.5 mx-8 w-16 self-center"></div>
)
